import type * as React from 'react';
import { getPaginated } from '@Domain/Api';
import staffMembersFetched, {
	type StaffMembersFetchedAction,
	type StaffMemberPayload,
} from '@Application/Facilities/StaffMembers/StaffMembers/Actions/staffMembersFetched';
import staffMembersFetchFailed, {
	type StaffMembersFetchFailedAction,
} from '@Application/Facilities/StaffMembers/StaffMembers/Actions/staffMembersFetchFailed';
import type FetchStaffMembers from '@Application/Facilities/StaffMembers/StaffMembers/Queries/FetchStaffMembers';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../../parameters';

type Actions = StaffMembersFetchedAction | StaffMembersFetchFailedAction;

type PaginatedStaffMembers = {
	totalRecords: number;
	results: StaffMemberPayload[];
};

export default (query: FetchStaffMembers) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			// Page indexing starts at 0 server-side, and `getPaginated` only walks every page when called
			// with `page: 0` — its internal guard only catches `page > 1`.
			const response = await getPaginated<PaginatedStaffMembers>(
				`${parameters.api.host}/api/organizations/${query.organizationId}/staff-members`,
				{ page: 0, rowsPerPage: 100 },
			);

			const action = staffMembersFetched(response.results, query.organizationId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = staffMembersFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
